module.exports = __webpack_public_path__ + "img/product1p.563724bf.png";